import * as React from 'react';

type ImageProps = { src: string; alt: string; className?: string };

const Image: React.FunctionComponent<ImageProps> = ({ src, alt, className }) => {
  return <img src={src} alt={alt} className={className} loading="lazy" />;
};

export default Image;
